"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNumberOfCaptionByVideoDuration = getNumberOfCaptionByVideoDuration;
exports.getCaptionPart = getCaptionPart;
exports.getCaptionsTiming = getCaptionsTiming;

var _mathUtils = require("./math-utils");

function getNumberOfCaptionByVideoDuration(videoDuration) {
  // icd = ideal caption duration
  const icd = videoDuration > 13 ? 5 : 4;
  return Math.min(Math.round(videoDuration / icd), videoDuration < 11 ? 2 : 7);
}

function getCaptionPart(videoLength, noc) {
  // noc = number of captions
  const captionDurationAndGap = videoLength / noc;
  const containerMaxLength = videoLength < 6 ? 3 : 5;
  const captionDuration = Math.min(Math.max(captionDurationAndGap * 0.9, 3), containerMaxLength);
  const gap = (0, _mathUtils.fixedNum)(Math.min(captionDurationAndGap - captionDuration, 1), 2);
  return {
    gap,
    captionDuration
  };
}

function getCaptionsTiming(videoLength) {
  const timing = {
    start: 0,
    end: 0
  };
  const numberOfCaption = getNumberOfCaptionByVideoDuration(videoLength);
  const {
    captionDuration,
    gap
  } = getCaptionPart(videoLength, numberOfCaption);
  const captions = [];
  let isOutro = false;

  for (let i = 0; i < numberOfCaption; i++) {
    isOutro = i === numberOfCaption - 1;
    let start;
    let end;

    if (isOutro) {
      start = (0, _mathUtils.fixedNum)(videoLength - captionDuration, 2);
      end = (0, _mathUtils.fixedNum)(videoLength, 2);
    } else {
      start = (0, _mathUtils.fixedNum)(i * captionDuration + (i + 1) * gap, 2);
      end = (0, _mathUtils.fixedNum)(i * captionDuration + (i + 1) * gap + captionDuration, 2);
    }

    captions.push({ ...timing,
      ...{
        start,
        end
      }
    });
  }

  return captions;
}